import { createAction, props } from '@ngrx/store';
import { PHASE_TWO } from '../../../model/phases.model';

export const ADD_PHASE_TWO = createAction(
  'ADD_PHASE_TWO',
  props<{ payload: PHASE_TWO }>()
);
